export const useInfiniteScrollSearchableSelectStyles = () => {
  return {
    container: {
      position: 'relative',
      width: '100%',
    },

    // Trigger styles - matching SelectField
    trigger: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 10px',
      border: '1px solid #CBCBCB',
      borderRadius: '0px',
      backgroundColor: '#FFFFFF',
      cursor: 'pointer',
      minHeight: '40px',
      transition: 'all 0.2s ease',
      '&:hover': {
        borderColor: '#050505',
        backgroundColor: '#FFFFFF',
      },
      '&:focus-within': {
        borderColor: '#050505',
        borderWidth: '1px',
      },
    },

    errorTrigger: {
      borderColor: '#d32f2f',
      '&:hover': {
        borderColor: '#d32f2f',
      },
      '&:focus-within': {
        borderColor: '#d32f2f',
        boxShadow: 'none',
      },
    },

    disabledTrigger: {
      backgroundColor: '#F0F0F0',
      cursor: 'not-allowed',
      opacity: 0.6,
      '&:hover': {
        borderColor: '#CBCBCB',
        backgroundColor: '#F0F0F0',
      },
    },

    triggerContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '2px',
      padding: '2px 4px',
    },

    label: {
      fontSize: '12px',
      fontFamily: 'Lexend',
      color: '#050505',
      fontWeight: 400,
      lineHeight: '15px',
      margin: '5px 0px',
      '& .required': {
        color: 'red',
      },
    },

    displayText: {
      fontSize: '14px',
      fontFamily: 'Lexend',
      fontWeight: 400,
      lineHeight: 1.2,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '150px',
      verticalAlign: 'middle',
      opacity: 0.5, // placeholder style
      '&.has-value': {
        opacity: 1,
      },
    },

    triggerActions: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      right: '12px',
      top: '6px',
    },

    clearButton: {
      padding: '4px',
      color: '#959595',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        color: '#656565',
      },
    },

    arrowIcon: {
      fontSize: '20px',
      color: '#656565',
      transition: 'transform 0.2s ease',
    },

    // Dropdown styles
    dropdown: {
      border: '1px solid #CBCBCB',
      borderRadius: '0px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      backgroundColor: '#FFFFFF',
      overflow: 'hidden',
    },

    searchContainer: {
      padding: '6px 8px',
      borderBottom: '1px solid #F0F0F0',
    },

    searchInput: {
      '& .MuiOutlinedInput-root': {
        fontFamily: 'Lexend',
        fontSize: '14px',
        fontWeight: '400',
        minHeight: '30px',
        borderRadius: '0px',
        background: '#FFFFFF',
        padding: '0 8px',
        '& fieldset': {
          borderColor: '#CBCBCB',
          borderRadius: '0px',
        },
        '&:hover fieldset': {
          borderColor: '#050505',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#050505',
          borderWidth: '1px',
        },
        '& .MuiInputBase-input': {
          padding: '2px 4px',
          fontSize: '14px',
          fontWeight: '400',
        },
      },
    },

    searchIcon: {
      fontSize: '18px',
      color: '#959595',
    },

    // Options list styles
    optionsList: {
      padding: 0,
      margin: 0,
      overflowY: 'auto',
      maxHeight: '200px',
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: '#F0F0F0',
        borderRadius: '3px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#CBCBCB',
        borderRadius: '3px',
        '&:hover': {
          backgroundColor: '#656565',
        },
      },
    },

    optionItem: {
      padding: '8px 10px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      borderBottom: '1px solid #F8F8F8',
      minHeight: '40px',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: '#F0F0F0',
      },
      '&:last-child': {
        borderBottom: 'none',
      },
    },

    selectedOption: {
      backgroundColor: '#A78D781A', // lightBeige
      '&:hover': {
        backgroundColor: '#A78D78', // secondary beige
        color: '#FFFFFF',
      },
    },

    optionText: {
      '& .MuiListItemText-primary': {
        fontSize: '14px',
        fontFamily: 'Lexend',
        fontWeight: '400',
        color: '#050505',
      },
    },

    // Loading states
    loadingContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      gap: '8px',
    },

    loadingText: {
      fontSize: '14px',
      fontFamily: 'Lexend',
      color: '#666666',
    },

    loadingMoreContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '12px',
      gap: '8px',
    },

    loadingMoreText: {
      fontSize: '12px',
      fontFamily: 'Lexend',
      color: '#666666',
    },

    // Empty state
    emptyContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    },

    emptyText: {
      fontSize: '14px',
      fontFamily: 'Lexend',
      color: '#666666',
      fontStyle: 'italic',
    },

    // Helper text
    helperText: {
      fontSize: '12px',
      fontFamily: 'Lexend',
      color: '#666666',
      marginTop: '4px',
      marginLeft: '10px',
    },

    errorText: {
      color: '#d32f2f',
    },
  };
}; 